export default "<app-campo-personalizado [localidade]=\"'/financeiro/pessoa/cliente'\"></app-campo-personalizado>";